import PropTypes from 'prop-types';
import React from 'react';

import { FIELD_TYPE } from 'Component/Field/Field.config';
import Form from 'Component/Form';
import GdprConsent from 'Component/GdprConsent/GdprConsent.container';
import {
    NewsletterSubscription as SourceNewsletterSubscription
} from 'SourceComponent/NewsletterSubscription/NewsletterSubscription.component';

import newsletterSubscriptionForm from './NewsletterForm.form';

import './NewsletterSubscription.override.style';

/** @namespace PeggysagePwa/Component/NewsletterSubscription/Component */
export class NewsletterSubscriptionComponent extends SourceNewsletterSubscription {
    static propTypes = {
        ...SourceNewsletterSubscription.propTypes,
        formId: PropTypes.string
    };

    static defaultProps = {
        formId: null
    };

    /**
     * Override: use local file
     */
    // eslint-disable-next-line @scandipwa/scandipwa-guidelines/only-render-in-component
    get fieldMap() {
        return newsletterSubscriptionForm();
    }

    renderGdprField() {
        const { formId } = this.props;

        return (
            <GdprConsent
              location="subscription"
              formId={ formId }
              mix={ { block: 'NewsletterSubscription', elem: 'Checkbox' } }
            />
        );
    }

    /**
     * Override: Modify button mods
     * @returns {JSX.Element}
     */
    renderActions() {
        return (
            <button
              type={ FIELD_TYPE.submit }
              block="Button"
              mods={ { isHollow: false } }
              aria-label={ __('Submit') }
            >
                { __('Subscribe') }
            </button>
        );
    }

    /**
     * Override: add gdpr field
     * @returns {JSX.Element}
     */
    renderFormBody() {
        const { isLoading } = this.props;

        return (
            <div block="FieldForm" elem="Fieldset" mods={ { isLoading } }>
                { super.renderFormBody() }
                { this.renderGdprField() }
            </div>
        );
    }

    /**
     * Override: add form id
     * @returns {JSX.Element}
     */
    render() {
        const { formId } = this.props;

        const formProps = this.getFormProps();
        if (formId) {
            if (!formProps.attr) {
                formProps.attr = {};
            }
            formProps.attr.id = formId;
        }

        return (
            <div block="NewsletterSubscription">
                { /* eslint-disable-next-line @scandipwa/scandipwa-guidelines/jsx-no-props-destruction */ }
                <Form { ...formProps } block="FieldForm">
                    { this.renderFormBody() }
                </Form>
            </div>
        );
    }
}

export default NewsletterSubscriptionComponent;
